import {CollectionFactory, Reducer, AsyncAction} from '@modifi/redux'
import {createSelector} from 'reselect'
import {getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'
import {ProviderType} from '@modifi/enums'

const apiClient = getAuthenticatedThemisClient()

const {actions, selectors, reducer} = CollectionFactory({
  actionNamePrefix: 'data/publicRegisteredCompanies/collection',
  rootSelector: state => state?.data?.publicRegisteredCompanies?.collection,
  fetchRequest: () =>
    apiClient.PublicRegisteredCompanies.all().then(res => res.data()?.resolutions || []),
  entityPrimaryKeySelector: ({provider}) => provider?.name!,
})

export default reducer as Reducer

export const selectPublicRegisteredCompaniesAreLoading = (state: Record<string, any>): boolean =>
  selectors.selectIsKeyWindowLoading(state, {})

const selectPublicRegisteredResolutionFromDataProvider = createSelector(
  (state: Record<string, any>) => selectors.selectByKeyWindow(state, {}),
  publicRegisteredCompanyResolutions =>
    publicRegisteredCompanyResolutions?.find?.(
      company => company?.provider?.type === ProviderType.DATA_PROVIDER
    ) || {}
)

export const selectPublicRegisteredCompanies = createSelector(
  selectPublicRegisteredResolutionFromDataProvider,
  publicRegisteredResolution => publicRegisteredResolution?.companies
)

export const selectPublicRegisteredCompaniesRetrievalStatus = createSelector(
  selectPublicRegisteredResolutionFromDataProvider,
  publicRegisteredResolution => publicRegisteredResolution?.retrievalStatus
)

const selectPublicRegisteredCompaniesFetchCount = (state: Record<string, any>): number =>
  selectors.selectFetchCountByKeyWindow(state, {})

export const selectPublicRegisteredCompaniesWhereLoaded = createSelector(
  selectPublicRegisteredCompaniesFetchCount,
  fetchCount => fetchCount > 0
)

export const selectHasPublicRegisteredCompanies = createSelector(
  selectPublicRegisteredCompanies,
  companies => companies && companies.length > 0
)

export const aFetchPublicRegisteredCompanies = (): AsyncAction => actions!.fetch({})

export const aEnsurePublicRegisteredCompanies =
  (): AsyncAction =>
  async (dispatch, getState): Promise<void> => {
    if (
      selectPublicRegisteredCompaniesAreLoading(getState()) ||
      selectPublicRegisteredCompaniesWhereLoaded(getState())
    ) {
      return undefined
    }
    return dispatch(aFetchPublicRegisteredCompanies())
  }
